import React from 'react';

import classes from './ExpertsHeader.module.scss';

const ExpertsHeader = () => {
	return (
		<div className={classes['header']}>
			<h1>
				Meet Our <span>Pharma Experts</span>
			</h1>
			<p>
				Our pharma mentors and instructors bring real experience from leading pharmaceutical
				companies to every course, review, and coaching session.
			</p>
		</div>
	);
};

export default ExpertsHeader;
